module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-07-8cf5d8e2eeffcbb11fb2936d13f762b9.jpg";